import { ThemeUtils, UrlUtils } from "../utils";
import React, { useMemo } from "react";
import { UISelectors, UserContextSelectors } from "../redux/selectors";
import { LogoState } from "./LogoState";
import PropTypes from "prop-types";
import SILinks from "../segmentedComponents/SI-links/index";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { LocalizationMessages } from "../localization/messages";
import { useIntl } from "react-intl";
import { ImgComponent } from "./common/ImgComponent";

const Logo = ({ onClick, id, className, trackingInfo, showAltLogo }) => {
  const { formatMessage } = useIntl();
  const config = useSelector(UISelectors.config);
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const onClickHandler = evt => {
    if (typeof onClick === "function") onClick(evt);
  };

  const trackingInfoLocal = useMemo(
    () =>
      trackingInfo
        ? Object.assign({}, trackingInfo, { dataLabel: "logo" })
        : Object.assign({}, trackingInfo, {
            dataCategory: "header",
            dataAction: "click",
            dataLabel: "logo"
          }),
    [trackingInfo]
  );

  const logoClasses = useMemo(
    () => classNames("aClogoBox", className),
    [className]
  );

  const logo = useMemo(() => {
    if (isMobile && config?.logoMobile) {
      return config?.logoMobile;
    } else {
      return config?.logo;
    }
  }, [config?.logo, config?.logoMobile, isMobile]);

  const logoAlt = useMemo(
    () => config?.logoAlt ?? config?.logo,
    [config?.logo, config?.logoAlt]
  );

  return (
    <>
      <div id={id} className={logoClasses}>
        {!isMobile && ThemeUtils.isSITheme() && (
          <SILinks trackingInfo={trackingInfo} />
        )}
        <ImgComponent
          onClick={onClickHandler}
          className="logoSVG"
          iconName={showAltLogo ? logoAlt : logo}
          alt={formatMessage(LocalizationMessages.seoLogoText)}
          hasLoadingIcon
          link={{
            href: UrlUtils.getCurrentOriginURLWithLang(window.location.origin),
            dataCategory: trackingInfoLocal.dataCategory,
            dataAction: trackingInfoLocal.dataAction,
            dataLabel: trackingInfoLocal.dataLabel,
            value: "",
            className: "logo-link"
          }}
        >
          <LogoState />
        </ImgComponent>
      </div>
    </>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  trackingInfo: PropTypes.object,
  showAltLogo: PropTypes.bool
};

export default Logo;
